/**
 * FILE: file-type.util.ts
 * CHỨC NĂNG: Các hàm kiểm tra loại file dựa trên MIME type và extension.
 * TÁC DỤNG: Dùng chung cho cả desktop và mobile — KHÔNG tự viết isImage/isVideo/isAudio riêng.
 *
 * Cách dùng:
 *   import { isImageFile, isVideoFile, isAudioFile, isImageUrl } from '@shared/utils/file-type.util';
 */

const IMAGE_EXTENSIONS = /\.(avif|gif|jpe?g|png|webp|bmp|svg)(?:\?.*)?$/i;
const VIDEO_EXTENSIONS = /\.(mp4|mov|m4v|webm|avi|mkv)(?:\?.*)?$/i;
const AUDIO_EXTENSIONS = /\.(aac|m4a|mp3|ogg|wav|flac|wma)(?:\?.*)?$/i;

/** Kiểm tra file có phải image không (theo MIME type hoặc extension). */
export function isImageFile(type?: string, url?: string): boolean {
    if (type?.startsWith('image/')) return true;
    return !!url && IMAGE_EXTENSIONS.test(url);
}

/** Kiểm tra file có phải video không (theo MIME type hoặc extension). */
export function isVideoFile(type?: string, url?: string): boolean {
    if (type?.startsWith('video/')) return true;
    return !!url && VIDEO_EXTENSIONS.test(url);
}

/** Kiểm tra file có phải audio không (theo MIME type hoặc extension). */
export function isAudioFile(type?: string, url?: string): boolean {
    if (type?.startsWith('audio/')) return true;
    return !!url && AUDIO_EXTENSIONS.test(url);
}

/** Kiểm tra URL có phải image không (chỉ theo extension, không có MIME). */
export function isImageUrl(url: string | null | undefined): boolean {
    return !!url && IMAGE_EXTENSIONS.test(url);
}

/** Kiểm tra URL có phải video không (chỉ theo extension). */
export function isVideoUrl(url: string | null | undefined): boolean {
    return !!url && VIDEO_EXTENSIONS.test(url);
}

/** Kiểm tra URL có phải audio không (chỉ theo extension). */
export function isAudioUrl(url: string | null | undefined): boolean {
    return !!url && AUDIO_EXTENSIONS.test(url);
}
